import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { useTourActions, useTourState } from "./TourProvider";

/**
 * Help (?) button for the top nav.
 * Only renders when a per-page tour is available for the current route.
 */
const HelpButton = () => {
  const { startPageTour } = useTourActions();
  const { currentPageTourId } = useTourState();

  if (!currentPageTourId) return null;

  return (
    <Tooltip title="What can I do here?">
      <IconButton
        onClick={() => startPageTour(currentPageTourId)}
        size="small"
        sx={{
          mr: 2,
          color: 'text.secondary',
          '&:hover': {
            color: 'primary.main',
          },
        }}
      >
        <HelpOutlineIcon />
      </IconButton>
    </Tooltip>
  );
};

export default HelpButton;
